import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  autocompleteData: {},
  autocompleteError: '',
  searchLoading: false,
  searchParam: '',
  selectedCategory: 'Browse All',
};

export const srpSearchSlice = createSlice({
  name: "srpSearch",
  initialState,
  reducers: {
    fetchAutocompleteRequest: (state) => {
      state.searchLoading = true;
    },
    fetchAutocompleteSuccess: (state, action) => {
      state.searchLoading = false;
      state.autocompleteData = action.payload;
      state.autocompleteError = '';
    },
    fetchAutocompleteFailure: (state, action) => {
      state.searchLoading = false;
      state.autocompleteError = action.payload;
    },
    setSearchParam: (state, action) => {
      state.searchParam = action.payload;
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
    setSearchLoading: (state) => {            
      state.searchLoading = true;
    }
  },
});

export const {
  fetchAutocompleteRequest,
  fetchAutocompleteSuccess,
  fetchAutocompleteFailure,
  setSearchParam,
  setSelectedCategory,setSearchLoading
} = srpSearchSlice.actions;
export const srpSearchData = (state) => (state.srpSearch)
export default srpSearchSlice.reducer;